import { Box } from "@mui/material";
import { CreateClusterAction } from "./CreateClusterAction";
import { CustomerEnvironment } from "utils/saastypes";

export const NoClusterContent = ({
  clusters,
}: {
  clusters?: CustomerEnvironment[];
}) => (
  <Box id="no-cluster-content" sx={{ py: 10, textAlign: "center" }}>
    <h3>
      {clusters?.length
        ? "No clusters match your filters"
        : "Create your first cluster"}
    </h3>
    <Box sx={{ width: 280, mx: "auto" }}>
      <CreateClusterAction
        clusters={clusters}
        messageId="cluster-capacity-empty"
      />
    </Box>
  </Box>
);
